<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconRaiseHand_16"
>
    <path
        d="M14.672 5.809a.953.953 0 0 0-1.174.665l-.764 2.76-.92-.255 1.528-5.519a.953.953 0 1 0-1.84-.509L9.975 8.47l-.92-.255s1.64-5.931 1.782-6.439a.953.953 0 1 0-1.84-.508L7.214 7.707l-.92-.255 1.528-5.519a.955.955 0 1 0-1.84-.509l-2.12 7.66c-.112.405-.655.407-.75-.003-.072-.32-.3-1.513-.462-2.369a.966.966 0 0 0-1.917.18c.003.733.015 1.824.055 2.735.156 3.552 3.658 5.194 5.357 5.664 2.094.58 4.117.647 5.644-.327 1.05-.67 1.882-1.962 2.28-3.404l1.268-4.578a.953.953 0 0 0-.665-1.173Z"
        fill="currentColor"
    />
</svg>
